/**
 * ConfirmModal Component
 * Replacement for browser confirm() with custom styling
 */

import Modal from './Modal'
import { AlertTriangle } from 'lucide-react'

export interface ConfirmModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  type?: 'info' | 'warning' | 'danger'
}

export function ConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = 'OK',
  cancelText = 'Cancel',
  type = 'warning',
}: ConfirmModalProps) {
  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <AlertTriangle size={24} color="#EF4444" />
      case 'warning':
        return <AlertTriangle size={24} color="#F59E0B" />
      default:
        return <AlertTriangle size={24} color="#3B82F6" />
    }
  }

  const getDefaultTitle = () => {
    switch (type) {
      case 'danger':
        return 'Confirm Action'
      case 'warning':
        return 'Confirm'
      default:
        return 'Confirm'
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title || getDefaultTitle()}
      maxWidth={450}
      closeOnBackdropClick={false} // Don't close on backdrop for confirms
      closeOnEscape={true}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button
            className="modal-button modal-button-secondary"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className={`modal-button ${type === 'danger' ? 'modal-button-danger' : 'modal-button-primary'}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmText}
          </button>
        </div>
      }
    >
      <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
        {getIcon()}
        <p style={{ margin: 0, flex: 1 }}>{message}</p>
      </div>
    </Modal>
  )
}
